import { format } from 'date-fns';

import { t } from 'state/intl/translations';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

function isValidDate(date: string | null | undefined): date is string {
  return typeof date === 'string' && date !== '' && date.slice(0, 4) !== '9999';
}

export function useOfferExpiration(
  endDate: string | null | undefined,
  expirationDate: string | null | undefined,
  isWalmartOffer: boolean
): string | null {
  let expiresAt: string | null = null;

  const enableOfferExpirationDisplay = useFlag(
    LaunchDarklyFlag.ENABLE_LOYALTY_OFFER_EXPIRATION_DISPLAY
  );

  if (enableOfferExpirationDisplay && !isWalmartOffer) {
    // Filter out invalid dates (those starting with '9999')
    const validDates: string[] = [];

    if (isValidDate(endDate)) {
      validDates.push(endDate);
    }

    if (isValidDate(expirationDate)) {
      validDates.push(expirationDate);
    }

    // Use the earliest date (the one that happens first)
    if (validDates.length > 0) {
      const earliestDate = validDates.reduce((earliest, current) => {
        return new Date(current) < new Date(earliest) ? current : earliest;
      });
      expiresAt = t('offerExpires', { date: format(new Date(earliestDate), 'MM/dd/yy') });
    }
  }
  return expiresAt;
}
